import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";
import Button from '../../button/Button';
import { 
    useChain,
    useWallet,
} from "../../../hooks/useEventStates";
import dispatchEvent from '../../../fns/common/dispatchEvent';
import injected from "../../../fns/wallets/injected";
import walletConnect from "../../../fns/wallets/walletConnect";

const Vip = () => {
    const account = useWallet();
    const chainId = useChain();

    return (
        <section className="home-vip">
            <div className="container mx-auto mx-auto md:pl-5 md:pr-5">
                <div className="flex flex-col xl:flex-row items-center">
                    <div className="w-full xl:w-1/3 mr-0 xl:mr-5">
                        <h1 className="lt-white font-bold mb-3">Become a MetaFans VIP</h1>
                        <h2 className="text-grey font-bold mb-5">Enjoy the ultimate community, epic parties, and VIP experiences from the best sports-focused NFT project on the blockchain.</h2>
                        <div className="flex flex-col lg:flex-row vip-ctas">
                            {!(account && chainId) ? (
                                <Button
                                    variant="Primary"
                                    className="font-bold self-start lg:self-auto mr-2"
                                    onClick={() => {
                                        const connector = window.ethereum ? injected : walletConnect;
                                        connector.connect().catch(err => toast.error(err.message));
                                      }}
                                >
                                    Connect Wallet
                                </Button>
                            ) : (
                                <Button
                                    variant="Primary"
                                    className="font-bold self-start lg:self-auto mr-2"
                                    onClick={() => dispatchEvent("opensaleModalRequested")}
                                >
                                    Mint
                                </Button>
                            )}
                            
                            <Link 
                                className="learn mt-2 lg:mt-0" 
                                to="/nft-utilities"
                            ><p className="text-white font-bold">Learn More</p></Link>
                        </div>
                    </div>
                    <div className="w-full xl:w-2/3 mt-5 md:mt-0 player">
                        <ReactPlayer
                            url="https://vimeo.com/724988531"
                            playing={true}
                            muted={true}
                            controls={true}
                            className="vip-promo"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Vip;